import { Badge, Box, Chip, CircularProgress, Stack, Tooltip } from "@mui/material";
import { estadosConcurso, estadoConcursoDescripcion } from "../utils/constants";

const ESTADOS_EN_ORDEN = [
  estadosConcurso.primeraRueda,
  estadosConcurso.segundaRueda,
  estadosConcurso.liguilla,
  estadosConcurso.nocheFallos,
  estadosConcurso.resultadosDisponibles
];

/**
 * Reemplaza la columna de texto plano del estado del concurso en la grilla.
 * Dos vueltas previas no entraban en el ancho real de una celda de
 * `DataGrid`: un `Stepper` con label completo debajo de cada paso (labels
 * como "Resultados disponibles" se recortaban) y después un `Stepper` de
 * puntos + `Chip` lado a lado (ambos con ancho mínimo propio, así que
 * terminaban superpuestos en vez de recortados). Acá no hay ningún elemento
 * con ancho mínimo fijo compitiendo por espacio: un anillo de progreso
 * (tamaño fijo chico, ~24px, no le compite ancho a nada) + un `Chip` con el
 * nombre del estado, que se achica solo (`minWidth: 0`) si el espacio real
 * es menor a su texto — con un badge si hay hallazgos bloqueantes vigentes
 * para la próxima transición.
 */
export const BarraProgresoConcurso = ({
  estadoActual,
  tieneHallazgosBloqueantes = false
}) => {
  const pasoActual = ESTADOS_EN_ORDEN.indexOf(estadoActual);

  const stepper = (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
      <Box sx={{ flexShrink: 0, lineHeight: 0 }}>
        <CircularProgress
          variant="determinate"
          value={((pasoActual + 1) / ESTADOS_EN_ORDEN.length) * 100}
          size={22}
          thickness={5}
          aria-label={`Paso ${pasoActual + 1} de ${ESTADOS_EN_ORDEN.length}`}
        />
      </Box>
      <Chip
        size="small"
        label={estadoConcursoDescripcion(estadoActual)}
        color="primary"
        variant="outlined"
        sx={{ minWidth: 0, "& .MuiChip-label": { overflow: "hidden", textOverflow: "ellipsis" } }}
      />
    </Stack>
  );

  if (!tieneHallazgosBloqueantes) {
    return stepper;
  }

  return (
    <Tooltip title="Hay hallazgos que bloquean la próxima transición de estado">
      <Badge color="error" variant="dot" sx={{ width: "100%" }}>
        {stepper}
      </Badge>
    </Tooltip>
  );
};

export default BarraProgresoConcurso;
